import { createContext, useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";

import { nanoid } from "nanoid";
import OverlayLoading from "../../components/forms/OverlayLoading";
import BreadcrumbOne from "../../components/forms/BreadcrumbOne";
import BackendToolsAPI from "../../api/backend/tools";
import { Button, Col, Form, ListGroup, Row } from "react-bootstrap";

import { CirclePicker } from "react-color";
import { FaTrash, FaChevronUp, FaChevronDown } from "react-icons/fa";

// import { createReactEditorJS } from "react-editor-js";

// import Embed from "@editorjs/embed";
// import Table from "@editorjs/table";
// import Paragraph from "@editorjs/paragraph";
// import List from "@editorjs/list";
// import Warning from "@editorjs/warning";
// import Code from "@editorjs/code";
// import LinkTool from "@editorjs/link";
// import Image from "@editorjs/image";
// import Raw from "@editorjs/raw";
// import Header from "@editorjs/header";
// import Quote from "@editorjs/quote";
// import Marker from "@editorjs/marker";
// import CheckList from "@editorjs/checklist";
// import Delimiter from "@editorjs/delimiter";
// import InlineCode from "@editorjs/inline-code";
// import SimpleImage from "@editorjs/simple-image";

const context = createContext();
// const ReactEditorJS = createReactEditorJS();

// const ReactEditorJSTools = {
//     embed: Embed,
//     table: Table,
//     list: List,
//     warning: Warning,
//     code: Code,
//     linkTool: LinkTool,
//     // image: Image,
//     raw: Raw,
//     header: Header,
//     quote: Quote,
//     marker: Marker,
//     checklist: CheckList,
//     delimiter: Delimiter,
//     inlineCode: InlineCode,
//     simpleImage: SimpleImage,
// };

const BackendToolPage = () => {
    const [state, setState] = useState([]);
    const [loading, setLoading] = useState(true);

    const handleClickAdd = useCallback(() => {
        setState((orig) => [...orig, { id: nanoid(10), icon: "", name: "", link: "", color: "" }]);
    }, []);

    const handleChangeUpdate = useCallback((event, v, name) => {
        v[name] = event.target.value;
        setState((orig) => orig.slice());
    }, []);

    const handleClickUp = useCallback((v) => {
        setState((orig) => {
            const index = orig.indexOf(v);

            if (index > 0) {
                const cache = orig[index];
                orig[index] = orig[index - 1];
                orig[index - 1] = cache;
            }

            return orig.slice();
        });
    }, []);

    const handleClickDown = useCallback((v) => {
        setState((orig) => {
            const index = orig.indexOf(v);

            if (index < orig.length - 1) {
                const cache = orig[index];
                orig[index] = orig[index + 1];
                orig[index + 1] = cache;
            }

            return orig.slice();
        });
    }, []);

    const handleClickDelete = useCallback((v) => {
        if (confirm("Are you sure?")) {
            setState((orig) => {
                const index = orig.indexOf(v);
                if (index >= 0) {
                    orig.splice(index, 1);
                }
                return orig.slice();
            });
        }
    }, []);

    const handleClickSubmit = (v) => {
        setLoading(true);
        BackendToolsAPI.update({ data: state }).finally(() => {
            setLoading(false);
        });
    };

    const fetchList = useCallback(() => {
        setLoading(() => true);
        BackendToolsAPI.all()
            .then((r) => setState(() => r.data ?? []))
            .finally(() => setLoading(() => false));
    }, []);

    useEffect(() => {
        loading && state.length === 0 && handleClickAdd();
    }, [state]);

    useEffect(() => {
        fetchList();
    }, [fetchList]);

    return (
        <context.Provider value={state}>
            <div className="position-relative">
                <BreadcrumbOne name="จัดการ link เครื่องมือ" />

                {/* <ReactEditorJS tools={ReactEditorJSTools} /> */}

                <ListGroup>
                    {state.map((v, i) => (
                        <ListGroup.Item key={v.id} className="position-relative">
                            <div className="d-flex gap-3">
                                <div style={{ flex: 1 }}>
                                    <Form.Group as={Row} className="mb-2">
                                        <Form.Label column sm="2" className="text-start text-lg-end">
                                            Icon
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control value={v.icon ?? ""} onChange={(e) => handleChangeUpdate(e, v, "icon")} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Form.Label column sm="2" className="text-start text-lg-end">
                                            Name
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control value={v.name ?? ""} onChange={(e) => handleChangeUpdate(e, v, "name")} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row} className="mb-2">
                                        <Form.Label column sm="2" className="text-start text-lg-end">
                                            Link
                                        </Form.Label>
                                        <Col sm="10">
                                            <Form.Control value={v.link ?? ""} onChange={(e) => handleChangeUpdate(e, v, "link")} />
                                        </Col>
                                    </Form.Group>

                                    <Form.Group as={Row}>
                                        <Form.Label column sm="2" className="text-start text-lg-end">
                                            Color
                                        </Form.Label>
                                        <Col sm="10">
                                            <CirclePicker
                                                color={v.color ?? ""}
                                                onChange={(e) => handleChangeUpdate({ target: { value: e.hex } }, v, "color")}
                                            />
                                        </Col>
                                    </Form.Group>
                                </div>

                                <div className="d-flex flex-column gap-2">
                                    <Button className="w-100" variant="dark">
                                        <span className="badge bg-dark fs-6">{i + 1}</span>
                                    </Button>

                                    <Button className="w-100" variant="danger" onClick={() => handleClickDelete(v)}>
                                        <FaTrash />
                                    </Button>

                                    <Button className="w-100" variant="light" onClick={() => handleClickUp(v)}>
                                        <FaChevronUp />
                                    </Button>

                                    <Button className="w-100" variant="light" onClick={() => handleClickDown(v)}>
                                        <FaChevronDown />
                                    </Button>
                                </div>
                            </div>
                        </ListGroup.Item>
                    ))}
                </ListGroup>

                <div className="d-flex flex-column flex-lg-row mt-3 gap-3">
                    <Button className="w-100" variant="light" onClick={handleClickAdd}>
                        Add
                    </Button>
                    <Button className="w-100" onClick={handleClickSubmit}>
                        Save
                    </Button>
                </div>

                {loading && <OverlayLoading />}
            </div>
        </context.Provider>
    );
};

export default BackendToolPage;
